import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { RealTimeService } from '../../../providers/real-time.service';


/**
 * Generated class for the PromptPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-prompt',
  templateUrl: 'prompt.html',
})
export class PromptPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,private alertCtrl: AlertController,
    private realTimeService: RealTimeService) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PromptPage');
  }

  stop(){
    let alert = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Confirmation',
      
      inputs: [
        {
          name: 'username',
          placeholder: 'nom d utilisateur'
        },
        {
          name: 'password',
          placeholder: 'Mot de passe',
          type: 'password'
        }
      ],
        buttons: [
          {
            text: 'confirmer',
            role: 'confirmer',
            handler: data => {
              console.log('dataaaaaaaa',JSON.stringify(data))
              this.stopEngine(this.navParams.data.selectedDevice,data)
             
            }
          },
          {
            text: 'Annuler',
            role: 'Annuler',
            handler: data => {
              
            }
          }
        ]
      });
      alert.present();
  }

  start(){
    let alert = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Confirmation',
      inputs: [
        {
          name: 'username',
          placeholder: 'nom d utilisateur'
        },
        {
          name: 'password',
          placeholder: 'Mot de passe',
          type: 'password'
        }
      ],
      buttons: [
        {
          text: 'confirmer',
          role: 'confirmer',
          handler: data => {
            console.log('dataaaaaaaa',data)
              this.startEngine(this.navParams.data.selectedDevice,data)
                
          }
        },
        {
          text: 'Annuler',
          role: 'Annuler',
          handler: data => {
            
          }
        }
      ]
    });
    alert.present();
  }

  //start moteur
  startEngine(deviceId,authData) {
    this.realTimeService.startEngine(deviceId,authData).subscribe(cmdSended => {
      alert("commande Lancement moteur envoyé !");
    });
  }

  //stop moteur
  stopEngine(deviceId,authData) {
    this.realTimeService.stopEngine(deviceId,authData).subscribe(cmdSended => {
      alert("commande Arrêt moteur envoyé !");
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/popping-pages/prompt/prompt.ts